<script>

import moment from "moment";

const items = {
  'en-cours': '',
  'en-livraison': 'En cours de transport',
  'commandé': 'Notre équipe prépare votre commande',
}
export default {
  name: 'DeliveryHistory',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      items
    }
  },
  computed: {
    viewStep1 () {
      return this.last.step === 'step-3' || this.last.step === 'step-2'
    },
    last () {
      return this.order.Workflow.at(-1)
    }
  },
  methods: {
    formatDate(date, daysToAdd) {
      return moment(date)
          .add(daysToAdd, 'days')
          .locale('fr')
          .format('DD MMM. YYYY')
    }
  }
}
</script>

<template>
  <div v-if="order.Workflow" class="mt-6 grow sm:mt-8 lg:mt-0">
    <div class="space-y-6 rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">Détail de livraison</h3>

      <ol  class="relative ms-3 border-s border-gray-200 dark:border-gray-700">
        <li v-if="last.text !== 'livré'" class="mb-10 ms-6">
              <span class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white dark:bg-gray-700 dark:ring-gray-800">
                <svg class="h-4 w-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
                </svg>
              </span>
          <h4 class="mb-0.5 text-base font-semibold text-gray-900 dark:text-white">
            Livraison estimée le {{ formatDate(order.orderAt, 7) }}
          </h4>
        </li>
        <li v-else class="mb-10 ms-6">
              <span class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white">
                <svg class="h-4 w-4 text-primary-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
                </svg>
              </span>
          <h4 class="mb-0.5 text-base font-semibold text-primary-700 dark:text-white">
            Livrée le {{ formatDate(order.orderAt, 7) }}
          </h4>
        </li>

        <li v-if="last.text !== 'livré'" class="mb-10 ms-6">
              <span class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white dark:bg-gray-700 dark:ring-gray-800">
                <svg class="h-4 w-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/>
                </svg>
              </span>
          <h4 class="mb-0.5 text-base font-semibold text-gray-900 dark:text-white">
            Aujourd'hui
          </h4>
          <p class="text-sm font-normal text-gray-500 dark:text-gray-400">
            {{ items[last.text] }}
          </p>
        </li>

        <li v-if="viewStep1" class="mb-10 ms-6 text-primary-700 dark:text-primary-500">
              <span class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                <svg class="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                </svg>
              </span>
          <h4 class="mb-0.5 font-semibold">
            {{ formatDate(order.orderAt, 3) }}
          </h4>
          <p class="text-sm">
            Commande expédiée par chronopost
          </p>
        </li>

        <li v-if="viewStep1" class="mb-10 ms-6 text-primary-700 dark:text-primary-500">
              <span class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                <svg class="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                </svg>
              </span>
          <h4 class="mb-0.5 text-base font-semibold">
            {{ formatDate(order.orderAt, 2) }}
          </h4>
          <p class="text-sm">
            Commande pris en charge par chronopost
          </p>
        </li>

        <li class="ms-6 text-primary-700 dark:text-primary-500">
              <span class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                <svg class="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                </svg>
              </span>
          <div>
            <h4 class="mb-0.5 font-semibold">
              {{ formatDate(order.orderAt, 0) }}
            </h4>
            <a href="#" class="text-sm font-medium hover:underline">
              Commande passée #{{ order.numberOrder }}
            </a>
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>

<style scoped>

</style>